import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { ErrorPageTypes } from '../errorpage/ErrorPage';
import { useSelector } from 'react-redux';
import { getIsGlifeContext } from '../selectors/settings-selectors';
import { AppState } from '../RootReducer';
import { LoginStatus } from '../http/Types';

// A user that is in the Glife context should never be able to interact with app in a logged out state, thus showing an error page if such thing happens.
const useGlifeLoggedOut = () => {
  const loginStatus = useSelector((state: AppState) => state.user.status);
	const isGlife = useSelector(getIsGlifeContext);
  const history = useHistory();

  useEffect(() => {
    const isLoggedOut = loginStatus === LoginStatus.LOGGED_OUT;

    if (isGlife && isLoggedOut) {
      history.replace(`/error-page/${ErrorPageTypes.GLIFE_LOGGED_OUT}`);
    }
  }, [isGlife, history, loginStatus]);

  return null;
};

export default useGlifeLoggedOut;